import { PageHeader } from '@/shared/ui/page';
import { formatRegisterNumber } from '@/shared/utils/format-register-number';
import { Tag } from '@noorden-insurtech/alba-design-system';
import { Building2, Mail } from 'lucide-react';
import { useBrokerDetails } from '../hooks';

interface BrokerHeaderProps {
  brokerId: string;
}

export function BrokerHeader({ brokerId }: BrokerHeaderProps) {
  const { broker, isLoading, isInactive } = useBrokerDetails(brokerId);

  return (
    <PageHeader.Root>
      <PageHeader.Main>
        <PageHeader.TitleGroup>
          <div className='flex items-start gap-4'>
            <div className='relative flex-shrink-0 self-start'>
              <div className='w-16 h-16 bg-alba-blue-500 rounded-full flex items-center justify-center mt-2'>
                <Building2 className='w-8 h-8 text-white' />
              </div>
            </div>
            <div className='flex flex-col'>
              <div className='flex flex-wrap items-center gap-3'>
                <PageHeader.Title>
                  {isLoading ? 'Carregando...' : broker?.name || 'Corretor'}
                </PageHeader.Title>
                {isInactive && (
                  <Tag.Root variant='outline' colorScheme='gray' size='sm'>
                    <Tag.Label>Inativo</Tag.Label>
                  </Tag.Root>
                )}
              </div>
              <p className='text-sm text-alba-gray-600'>
                CNPJ: {formatRegisterNumber(broker?.licenseNumber)}
              </p>
              <div className='flex items-center gap-4'>
                <div className='flex items-center gap-1'>
                  <Mail className='w-4 h-4 text-alba-gray-600' />
                  <span className='text-sm text-alba-gray-600'>
                    {broker?.email || 'N/A'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </PageHeader.TitleGroup>
      </PageHeader.Main>
    </PageHeader.Root>
  );
}
